import styled from 'styled-components';

export const Container = styled.div`
  padding-top: 32px;
`;
